import ResendConfirmAccountNotify from './resend-confirm-account-notify';

export default ResendConfirmAccountNotify;
